module.exports = __webpack_public_path__ + "static/kalyan_matrimony-13b516c31632b8a7c05f4bb5b5f56063.gif";